import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Practices from "../pages/practices/page";
import Register from "../pages/register/page";
import Playbook from "../pages/playbook/page";
import FormerPlayers from "../pages/former-players/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/practices", element: <Practices /> },
  { path: "/programs", element: <Register /> },
  { path: "/tools", element: <Playbook /> },
  { path: "/former-players", element: <FormerPlayers /> },

  // Legacy URL redirects
  { path: "/playbook", element: <Navigate to="/tools" replace /> },
  { path: "/register", element: <Navigate to="/programs" replace /> },
  { path: "/pay-here", element: <Navigate to="/programs" replace /> },
  { path: "/summer-camps", element: <Navigate to="/programs" replace /> },
  { path: "/green-light-shooter", element: <Navigate to="/tools" replace /> },
  { path: "/home-leader-board", element: <Navigate to="/former-players" replace /> },

  { path: "*", element: <NotFound /> },
];

export default routes;
